import { EmbeddedTableRowRowSpan, RowWithEmbeddedTableRowInfo } from './Types';

export const getEmbeddedTableRowRowSpan = <TData>(
  row: RowWithEmbeddedTableRowInfo<TData> | undefined,
  parentColumnPath: string | undefined,
): EmbeddedTableRowRowSpan | null => {
  if (!row || !parentColumnPath) {
    return null;
  }
  return row.embeddedTableRowRowSpans[parentColumnPath] ?? null;
};
